import React, { useEffect } from "react";
import { Button, Input } from "antd";
import FormLabel from "../../../../../common/Form/FormLabel";
import { CheckCircleOutlined, SaveOutlined } from "@ant-design/icons";
import * as Yup from "yup";
import { getOneExerciceAuditClient } from "../../../../../../data/exercice";

const observationSchema = Yup.object().shape({
  observation: Yup.string()
    .trim()
    .min(10, "L'observation doit contenir au moins 10 caractères")
    .max(5000, "L'observation ne peut pas dépasser 5000 caractères")
    .required("L'observation est obligatoire"),
});

const ObservationGenerale = ({
  observation,
  setObservation,
  onSaveObservation,
  saveLoading,
  exerciceAuditClient,
  setExerciceAuditClient,
}) => {
  // ✅ Second useEffect : Charger les détails de l'exercice SEULEMENT après initialisation
  useEffect(() => {
    // ✅ N'exécuter que si exerciceAuditClient est défini et a un ID
    if (exerciceAuditClient?.id && exerciceAuditClient?.client_bog_id) {
      const fetchExerciceDetails = async () => {
        try {
          const res = await getOneExerciceAuditClient(
            exerciceAuditClient?.id,
            exerciceAuditClient?.client_bog_id
          );

          if (res) {
            // ✅ Mettre à jour l'observation avec les données les plus récentes
            if (res.observation_generale !== undefined) {
              setObservation(res.observation_generale);
            }

            // ✅ Mettre à jour l'objet complet si nécessaire
            setExerciceAuditClient((prevState) => ({
              ...prevState,
              ...res,
            }));
          }
        } catch (error) {
          console.error("Erreur lors du chargement des détails:", error);
        }
      };

      fetchExerciceDetails();
    }
  }, [exerciceAuditClient?.id, exerciceAuditClient?.client_bog_id]); // ✅ Dépendances spécifiques

  return (
    <div className="px-4 py-6">
      <div className="d-flex flex-column">
        <FormLabel required label="Observation générale : (à préciser)" />
        <Input.TextArea
          size="large"
          placeholder="Saisissez votre observation générale concernant la lettre de mission..."
          value={observation || ""}
          onChange={(e) => {
            setObservation(e.target.value);
          }}
          style={{
            width: "100%",
            minHeight: "200px",
            backgroundColor: "white",
          }}
          /* showCount
          maxLength={5000} */
          autoSize={{
            minRows: 8,
            maxRows: 15,
          }}
        />

        <div
          style={{
            marginTop: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {/* ✅ Indication du statut */}
          <div style={{ marginTop: "-30px", fontSize: "12px", color: "#666" }}>
            <span>
              {observation && observation.trim()
                ? `${observation.trim().length} caractères saisis`
                : "Aucune observation saisie"}
            </span>
          </div>

          <div>
            <Button
              type={"primary"}
              size="large"
              icon={<SaveOutlined />}
              loading={saveLoading}
              onClick={onSaveObservation}
              style={{
                opacity: saveLoading ? 0.7 : 1,
              }}
            >
              {saveLoading ? "Sauvegarde en cours" : "Sauvegarder"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export { ObservationGenerale };
